import { HttpErrorResponse } from '@angular/common/http';

export interface IApiState<K = null> {
  loading: boolean;
  notify: boolean;
  error: boolean;
  errorResponse: HttpErrorResponse | null;
  data: K | null;
  updating?: boolean;

  load: (initialData?: K) => ApiState<K>;
  update: (initialData?: K) => ApiState<K>;
  success: (data: K) => ApiState<K>;
  setError: (errorResponse?: HttpErrorResponse | null, initialData?: K) => ApiState<K>;
}

export class ApiState<T = null> implements IApiState<T> {
  data: T | null = null;
  error: boolean = false;
  errorResponse: HttpErrorResponse | null = null;
  loading: boolean = false;
  notify: boolean = false;
  updating: boolean = false;

  constructor(data?: T) {
    if (data) {
      this.data = data;
    }
  }

  load<T>(initialData?: T): ApiState<T> {
    const newState: ApiState<T> = new ApiState<T>(initialData);
    newState.loading = true;
    return newState;
  }

  update<T>(initialData?: T): ApiState<T> {
    const newState: ApiState<T> = new ApiState<T>(initialData);
    newState.updating = true;
    return newState;
  }

  success<T>(data: T): ApiState<T> {
    const newState: ApiState<T> = new ApiState<T>(data);
    newState.notify = true;
    return newState;
  }

  setError<T>(errorResponse?: HttpErrorResponse | null, initialData?: T): ApiState<T> {
    const newState: ApiState<T> = new ApiState<T>(initialData);
    newState.error = true;
    newState.errorResponse = errorResponse ?? null;
    return newState;
  }
}
